import { ReportType, ChartType, ReportView, ReportRoleType, SortType } from '@/commons/enumReport.js';
import DateEnum from '@/components/dashboard-filter/dateEnum.js';
import MSConstant from '@/i18ns/vi/i18nEnum.js';
import i18nCommon from '../../i18ns/vi/i18nCommon';

/**
 * Get gía trị ngày đầu và cuối của tháng này
 * @returns Object {startDate: Ngày bắt đầu, endDate: Ngày kết thúc}
 * @author: THNhat(17/01/2022)
 */
const getRangeDateThisMonth = () => {
  const curr = new Date(); // get current date

  let startDate = new Date(curr.getFullYear(), curr.getMonth(), 1);
  let endDate = new Date(curr.getFullYear(), curr.getMonth() + 1, 0);
  return { startDate, endDate };
}

const objectRange = getRangeDateThisMonth();

// 1
export const useStateChart = {
  caption: 'Tình hình sử dụng',
  type: ReportType.UseState,
  chartType: ChartType.Table,
  desc: '',
  isPossibleAddMany: false,
  h: 7,
  w: 12,
  param: {
    organization: [],
    sorts: {
      sortValue: [
        {
          SortID: 2,
          SortName: "Tổng số công việc đã giao",
          SortValue: "NumberOfTaskAssigner"
        }
      ],
      sortType: SortType.DESC
    }
  },
  view: ReportView.OperateByMe,
}

// 2
export const workStateChart = {
  caption: 'Tổng quan tình hình công việc',
  type: ReportType.WorkState,
  chartType: ChartType.Card,
  desc: '',
  isPossibleAddMany: false,
  h: 4,
  w: 12,
  param: {
    date: {
      comboboxValue: [
        {
          SettingValue: DateEnum.ThisMonth,
          SettingName: MSConstant.ReportPeriod.ThisMonth,
        }
      ],
      startDate: null,
      endDate: null,
    },
  },
  view: ReportView.OperateByMe,
}

// 3
export const structureByWorkTypeChart = {
  caption: 'Cơ cấu công việc theo loại việc',
  type: ReportType.StructureByWorkType,
  chartType: ChartType.Circle,
  desc: '',
  isPossibleAddMany: false,
  h: 7,
  w: 6,
  param: {
    date: {
      comboboxValue: [
        {
          SettingValue: DateEnum.ThisMonth,
          SettingName: MSConstant.ReportPeriod.ThisMonth,
        }
      ],
      startDate: null,
      endDate: null,
    },
  },
  view: ReportView.OperateByMe,
}

// 4
export const stateByWorkTypeChart = {
  caption: 'Tình trạng công việc theo loại việc',
  type: ReportType.StateByWorkType,
  chartType: ChartType.Circle,
  desc: '',
  isPossibleAddMany: true,
  h: 7,
  w: 6,
  param: {
    date: {
      comboboxValue: [
        {
          SettingValue: DateEnum.ThisMonth,
          SettingName: MSConstant.ReportPeriod.ThisMonth,
        }
      ],
      startDate: null,
      endDate: null,
    },
  },
  view: ReportView.OperateByMe,
}

// 5
export const stateExecuteWorkChart = {
  caption: 'Tình hình thực hiện công việc',
  type: ReportType.StateExecuteWork,
  chartType: ChartType.Table,
  desc: '',
  isPossibleAddMany: false,
  h: 6,
  w: 12,
  param: {
    type: [
      {
        TypeID: 1,
        TypeName: i18nCommon.All,
      }
    ],
    organization: [],
    date: {
      comboboxValue: [
        {
          SettingValue: DateEnum.ThisMonth,
          SettingName: MSConstant.ReportPeriod.ThisMonth,
        }
      ],
      startDate: null,
      endDate: null,
    },
    roleType: [
      {
        RoleID: ReportRoleType.Executor,
        RoleName: i18nCommon.DashBoard.Executor
      }
    ],
  },
  view: ReportView.OperateByMe,
}

// 6
export const statisticsByWorkTypeChart = {
  caption: 'Thống kê công việc theo loại việc',
  type: ReportType.StatisticsByWorkType,
  chartType: ChartType.Table,
  desc: '',
  isPossibleAddMany: false,
  h: 6,
  w: 12,
  param: {
    date: {
      comboboxValue: [{
        SettingValue: DateEnum.ThisMonth,
        SettingName: MSConstant.ReportPeriod.ThisMonth,
      }],
      startDate: null,
      endDate: null,
    },
    organization: [],
    roleType: [{
      RoleID: ReportRoleType.Executor,
      RoleName: "Chủ trì"
    }]
  },
  view: ReportView.OperateByMe,
}

// 7
export const compareStateExecuteWorkChart = {
  caption: 'So sánh tình hình thực hiện công việc',
  type: ReportType.CompareStateExecuteWork,
  chartType: ChartType.Table,
  desc: '',
  isPossibleAddMany: false,
  h: 7,
  w: 12,
  param: {
    type: [
      {
        TypeID: 1,
        TypeName: i18nCommon.All,
      }
    ],
    organization: [],
    period: {
      comboboxValue: [{
        TypeID: DateEnum.Month,
        TypeName: i18nCommon.DashBoard.Month,
      }],
      startDate: objectRange.startDate,
      endDate: objectRange.endDate,
      startDatePeriod: objectRange.startDate,
      endDatePeriod: objectRange.endDate
    },
    roleType: [
      {
        RoleID: ReportRoleType.Executor,
        RoleName: i18nCommon.DashBoard.Executor
      }
    ],
  },
  view: ReportView.OperateByMe,
}

// 9
export const workOverviewChart = {
  caption: 'Tổng quan công việc',
  type: ReportType.WorkOverview,
  chartType: ChartType.Card,
  desc: '',
  isPossibleAddMany: false,
  h: 4,
  w: 12,
  param: {
    date: {
      comboboxValue: [
        {
          SettingValue: DateEnum.ThisMonth,
          SettingName: MSConstant.ReportPeriod.ThisMonth,
        }
      ],
      startDate: null,
      endDate: null,
    },
  },
  view: ReportView.Personality,
}

// 10
export const workStateOverviewByRoleChart = {
  caption: 'Tình trạng công việc tôi đã giao',
  type: ReportType.WorkStateOverviewByRole,
  chartType: ChartType.Circle,
  desc: '',
  isPossibleAddMany: false,
  h: 7,
  w: 6,
  param: {
    date: {
      comboboxValue: [{
        SettingValue: DateEnum.ThisMonth,
        SettingName: MSConstant.ReportPeriod.ThisMonth,
      }]
    },
    roleType: [
      {
        RoleID: ReportRoleType.Assigner,
        RoleName: i18nCommon.DashBoard.Assigner
      }
    ],
  },
  view: ReportView.Personality,
}

// 11
export const workTypeOverviewByRoleChart = {
  caption: 'Cơ cấu loại việc theo vai trò tôi đã giao',
  type: ReportType.WorkTypeOverviewByRole,
  chartType: ChartType.Circle,
  desc: '',
  isPossibleAddMany: false,
  h: 7,
  w: 6,
  param: {
    roleType: ReportRoleType.Assigner,
    date: {
      comboboxValue: [
        {
          SettingValue: DateEnum.ThisMonth,
          SettingName: MSConstant.ReportPeriod.ThisMonth,
        }
      ],
      startDate: null,
      endDate: null,
    },
  },
  view: ReportView.Personality,
}

// 12
export const workStateOverviewByRoleAndWorkTypeChart = {
  caption: 'Tình trạng công việc theo vai trò - loại việc',
  type: ReportType.WorkStateOverviewByRoleAndWorkType,
  chartType: ChartType.Circle,
  desc: '',
  isPossibleAddMany: true,
  h: 7,
  w: 6,
  param: {
    type: [
      {
        TypeID: 'Chính phủ giao',
        TypeName: 'Chính phủ giao',
      }
    ],
    roleType: [
      {
        RoleID: ReportRoleType.Executor,
        RoleName: i18nCommon.DashBoard.Executor
      }
    ],
    date: {
      comboboxValue: [
        {
          SettingValue: DateEnum.ThisMonth,
          SettingName: MSConstant.ReportPeriod.ThisMonth,
        }
      ],
      startDate: null,
      endDate: null,
    },
  },
  view: ReportView.Personality,
}

// 13
export const authorizationWorkChart = {
  caption: 'Tôi được ủy quyền',
  type: ReportType.AuthorizationWork,
  chartType: ChartType.Table,
  desc: '',
  isPossibleAddMany: false,
  h: 7,
  w: 6,
  param: {},
  view: ReportView.Personality,
}

// 14
export const remindWorkChart = {
  caption: 'Công việc đã giao cần thực hiện',
  type: ReportType.RemindWork,
  chartType: ChartType.Table,
  desc: '',
  isPossibleAddMany: false,
  h: 5,
  w: 12,
  param: {
    roleType: ReportRoleType.Assigner,
    timeRemind: 3
  },
  view: ReportView.Personality,
}

// 15
export const workStateToExecuteChart = {
  caption: 'Tình hình thực hiện công việc',
  type: ReportType.WorkStateToExecute,
  chartType: ChartType.Table,
  desc: '',
  isPossibleAddMany: false,
  h: 7,
  w: 6,
  param: {
    type: [
      {
        TypeID: 1,
        TypeName: i18nCommon.All,
      }
    ],
    roleType: [
      {
        RoleID: ReportRoleType.Executor,
        RoleName: i18nCommon.DashBoard.Executor
      }
    ],
    date: {
      comboboxValue: [
        {
          SettingValue: DateEnum.ThisMonth,
          SettingName: MSConstant.ReportPeriod.ThisMonth,
        }
      ],
      startDate: null,
      endDate: null,
    },
  },
  view: ReportView.Personality,
}

// 16
export const workStateToEvaluateChart = {
  caption: 'Đánh giá tình hình thực hiện công việc',
  type: ReportType.WorkStateToEvaluate,
  chartType: ChartType.Table,
  desc: '',
  isPossibleAddMany: false,
  h: 7,
  w: 6,
  param: {
    type: [
      {
        TypeID: 1,
        TypeName: i18nCommon.All,
      }
    ],
    roleType: [
      {
        RoleID: ReportRoleType.Executor,
        RoleName: i18nCommon.DashBoard.Executor
      }
    ],
    date: {
      comboboxValue: [
        {
          SettingValue: DateEnum.ThisMonth,
          SettingName: MSConstant.ReportPeriod.ThisMonth,
        }
      ],
      startDate: null,
      endDate: null,
    },
  },
  view: ReportView.Personality,
}

/**
 * Các biểu đồ có thể thêm của tab Tôi quản lý
 */
export const operateByMeCharts = [
  {
    ...useStateChart,
    desc: 'Xem thống kê số lượng công việc từ khi sử dụng phần mềm theo số lượng công việc  đã giao, đã duyệt, chủ trì và số cập nhật tiến độ',
  },
  {
    ...workStateChart,
    desc: 'Xem tổng quan số lượng công việc theo trạng thái',
  },
  {
    ...structureByWorkTypeChart,
    desc: 'Xem tổng quan số lượng công việc theo loại việc',
  },
  {
    ...stateByWorkTypeChart,
    desc: 'Xem tổng quan tình trạng công việc theo từng loại việc',
    param: {
      ...stateByWorkTypeChart.param,
      type: [
        {
          TypeID: 1,
          TypeName: i18nCommon.All,
        }
      ],
    },
  },
  {
    ...stateExecuteWorkChart,
    desc: 'Xem chi tiết số lượng công việc của đơn vị theo tình trạng',
  },
  {
    ...statisticsByWorkTypeChart,
    desc: 'Xem chi tiết số lượng công việc của đơn vị theo loại việc',
  },
  {
    ...compareStateExecuteWorkChart,
    desc: 'Xem chi tiết số lượng công việc giữa 2 kỳ của đơn vị theo trạng thái',
  },
]

/**
 * Các biểu đồ có thể thêm của tab Đơn vị tôi
 */
export const myOrgCharts = [
  {
    ...useStateChart,
    desc: 'Xem thống kê số lượng công việc từ khi sử dụng phần mềm theo số lượng công việc  đã giao, đã duyệt, chủ trì và số cập nhật tiến độ',
    view: ReportView.MyOrg,
  },
  {
    ...workStateChart,
    desc: 'Xem tổng quan số lượng công việc theo trạng thái',
    view: ReportView.MyOrg,
  },
  {
    ...structureByWorkTypeChart,
    desc: 'Xem tổng quan số lượng công việc theo loại việc',
    view: ReportView.MyOrg,
  },
  {
    ...stateByWorkTypeChart,
    desc: 'Xem tổng quan tình trạng công việc theo từng loại việc',
    param: {
      ...stateByWorkTypeChart.param,
      type: [
        {
          TypeID: 1,
          TypeName: i18nCommon.All,
        }
      ],
    },
    view: ReportView.MyOrg,
  },
  {
    ...stateExecuteWorkChart,
    desc: 'Xem chi tiết số lượng công việc của đơn vị theo tình trạng',
    view: ReportView.MyOrg,
  },
  {
    ...statisticsByWorkTypeChart,
    desc: 'Xem chi tiết số lượng công việc của đơn vị theo loại việc',
    view: ReportView.MyOrg,
  },
  {
    ...compareStateExecuteWorkChart,
    desc: 'Xem chi tiết số lượng công việc giữa 2 kỳ của đơn vị theo trạng thái',
    view: ReportView.MyOrg,
  },
]

/**
 * Các biểu đồ có thể thêm của tab Của tôi
 */
export const personalityCharts = [
  {
    ...workOverviewChart,
    desc: 'Xem tổng quan số lượng công việc tôi đã giao, tôi chủ trì, tôi phối hợp, tôi liên quan',
  },
  {
    ...remindWorkChart,
    desc: 'Xem danh sách nhắc việc tôi đã giao cần thực hiện',
  },
  {
    ...remindWorkChart,
    caption: 'Công việc phụ trách cần thực hiện',
    desc: 'Xem danh sách nhắc việc tôi phụ trách cần thực hiện',
    param: { ...remindWorkChart.param, roleType: ReportRoleType.Supervisor },
  },
  {
    ...remindWorkChart,
    caption: 'Công việc chủ trì cần thực hiện',
    desc: 'Xem danh sách nhắc việc tôi chủ trì cần thực hiện',
    param: { ...remindWorkChart.param, roleType: ReportRoleType.Executor },
  },
  {
    ...workStateOverviewByRoleChart,
    desc: 'Xem tổng quan tình trạng công việc mà tôi đã giao',
  },
  {
    ...workStateOverviewByRoleChart,
    caption: 'Tình trạng công việc tôi phụ trách',
    desc: 'Xem tổng quan tình trạng công việc mà tôi phụ trách',
    param: { ...workStateOverviewByRoleChart.param, roleType: [{ RoleID: ReportRoleType.Supervisor, RoleName: i18nCommon.DashBoard.Supervisor }] },
  },
  {
    ...workStateOverviewByRoleChart,
    caption: 'Tình trạng công việc tôi chủ trì',
    desc: 'Xem tổng quan tình trạng công việc mà tôi chủ trì',
    param: { ...workStateOverviewByRoleChart.param, roleType: [{ RoleID: ReportRoleType.Executor, RoleName: i18nCommon.DashBoard.Executor }] },
  },
  {
    ...workStateOverviewByRoleChart,
    caption: 'Tình trạng công việc tôi phối hợp',
    desc: 'Xem tổng quan tình trạng công việc mà tôi phối hợp',
    param: { ...workStateOverviewByRoleChart.param, roleType: [{ RoleID: ReportRoleType.Combination, RoleName: i18nCommon.DashBoard.Combination }] },
  },
  {
    ...authorizationWorkChart,
    desc: 'Xem tổng quan tình hinh công việc tôi đang được ủy quyền',
  },
  {
    ...workTypeOverviewByRoleChart,
    desc: 'Xem tổng quan số lượng công việc tôi đã giao theo loại việc',
  },
  {
    ...workTypeOverviewByRoleChart,
    caption: 'Cơ cấu loại việc theo vai trò tôi chủ trì',
    desc: 'Xem tổng quan số lượng công việc tôi chủ trì theo loại việc',
    param: { ...workTypeOverviewByRoleChart.param, roleType: ReportRoleType.Executor },
  },
  {
    ...workTypeOverviewByRoleChart,
    caption: 'Cơ cấu loại việc theo vai trò tôi phối hợp',
    desc: 'Xem tổng quan số lượng công việc tôi phối hợp theo loại việc',
    param: { ...workTypeOverviewByRoleChart.param, roleType: ReportRoleType.Combination },
  },
  {
    ...workStateOverviewByRoleAndWorkTypeChart,
    desc: 'Xem tình trạng công việc theo vai trò và loại công việc',
  },
  {
    ...workStateToExecuteChart,
    desc: 'Xem chi tiết số lượng công việc theo tình trạng đến thời điểm mới nhất',
  },
  {
    ...workStateToEvaluateChart,
    desc: 'Xem chi tiết số lượng công việc theo tình trạng trong thời gian báo cáo',
  },
  {
    ...compareStateExecuteWorkChart,
    desc: 'Xem chi tiết số lượng công việc giữa 2 kỳ theo từng trạng thái',
    h: 7,
    w: 6,
    view: ReportView.Personality,
  },
  {
    ...statisticsByWorkTypeChart,
    desc: 'Xem chi tiết số lượng công việc theo loại việc',
    h: 7,
    w: 6,
    view: ReportView.Personality,
  },
]

/**
 * Các tab màn tổng quản mặc định
 */
export const defaultDashboardTabs = {
  /**
   * Tab tôi quản lý
   */
  operateByMe: [
    {
      ...operateByMeCharts[0],
      i: '0',
      x: 0,
      y: 0,
    },
    {
      ...operateByMeCharts[1],
      i: '1',
      x: 0,
      y: 7,
    },
    {
      ...operateByMeCharts[2],
      i: '2',
      x: 0,
      y: 11,
    },
    {
      ...operateByMeCharts[3],
      i: '3',
      x: 6,
      y: 11,
      param: {
        ...stateByWorkTypeChart.param,
        type: [
          {
            TypeID: MSConstant.TaskType.UBNDPlan,
            TypeName: MSConstant.TaskType.UBNDPlan,
          }
        ]
      },
    },
    {
      ...operateByMeCharts[3],
      i: '4',
      x: 0,
      y: 18,
      param: {
        ...stateByWorkTypeChart.param,
        type: [
          {
            TypeID: MSConstant.TaskType.Arise,
            TypeName: MSConstant.TaskType.Arise,
          }
        ]
      },
    },
    {
      ...operateByMeCharts[3],
      i: '5',
      x: 6,
      y: 18,
      param: {
        ...stateByWorkTypeChart.param,
        type: [
          {
            TypeID: MSConstant.TaskType.OrganizationPlan,
            TypeName: MSConstant.TaskType.OrganizationPlan,
          }
        ]
      },
    },
    {
      ...operateByMeCharts[4],
      i: '6',
      x: 0,
      y: 25,
    },
  ],

  /**
   * Tab đơn vi tôi
   */
  myOrg: [
    {
      ...myOrgCharts[0],
      i: '0',
      x: 0,
      y: 0,
    },
    {
      ...myOrgCharts[1],
      i: '1',
      x: 0,
      y: 7,
    },
    {
      ...myOrgCharts[2],
      i: '2',
      x: 0,
      y: 11,
    },
    {
      ...myOrgCharts[3],
      i: '3',
      x: 6,
      y: 11,
      param: {
        ...stateByWorkTypeChart.param,
        type: [
          {
            TypeID: MSConstant.TaskType.UBNDPlan,
            TypeName: MSConstant.TaskType.UBNDPlan,
          }
        ]
      },
    },
    {
      ...myOrgCharts[3],
      i: '4',
      x: 0,
      y: 18,
      param: {
        ...stateByWorkTypeChart.param,
        type: [
          {
            TypeID: MSConstant.TaskType.Arise,
            TypeName: MSConstant.TaskType.Arise,
          }
        ]
      },
    },
    {
      ...myOrgCharts[3],
      i: '5',
      x: 6,
      y: 18,
      param: {
        ...stateByWorkTypeChart.param,
        type: [
          {
            TypeID: MSConstant.TaskType.OrganizationPlan,
            TypeName: MSConstant.TaskType.OrganizationPlan,
          }
        ]
      },
    },
    {
      ...myOrgCharts[4],
      i: '6',
      x: 0,
      y: 25,
    },
  ],

  /**
   * Tab của tôi (dùng cho người dùng chuyên viên)
   */
  personality: [
    {
      ...personalityCharts[0],
      i: '0',
      x: 0,
      y: 0,
    },
    {
      ...personalityCharts[3],
      i: '1',
      x: 0,
      y: 4,
    },
    {
      ...personalityCharts[6],
      i: '2',
      x: 0,
      y: 9,
    },
    {
      ...personalityCharts[13],
      i: '3',
      x: 0,
      y: 14,
    },
    {
      ...personalityCharts[7],
      i: '4',
      x: 6,
      y: 14,
    },
  ],

  /**
   * Tab của tôi vip pro
   */
  personalityPro: [
    {
      ...personalityCharts[0],
      i: '0',
      x: 0,
      y: 0,
    },
    {
      ...personalityCharts[1],
      i: '1',
      x: 0,
      y: 4,
    },
    {
      ...personalityCharts[2],
      i: '2',
      x: 0,
      y: 9,
    },
    {
      ...personalityCharts[3],
      i: '3',
      x: 0,
      y: 14,
    },
    {
      ...personalityCharts[4],
      i: '4',
      x: 0,
      y: 19,
    },
    {
      ...personalityCharts[5],
      i: '5',
      x: 6,
      y: 19,
    },
    {
      ...personalityCharts[6],
      i: '6',
      x: 0,
      y: 26,
    },
    {
      ...personalityCharts[7],
      i: '7',
      x: 6,
      y: 26,
    },
    {
      ...personalityCharts[13],
      i: '8',
      x: 0,
      y: 33,
    },
  ],
};

/**
 * Map key từ option sang dashboard
 */
export const MapOptionKeyToDashboardTabKey = {
  ReportViewEnumOperateByMe: 'operateByMe',
  ReportViewEnumMyOrg: 'myOrg',
  ReportViewEnumPersonality: 'personality',
}

/**
 * Map key từ dashboard sang option
 */
export const MapDashboardTabKeyToOptionKey = {
  operateByMe: 'ReportViewEnumOperateByMe',
  myOrg: 'ReportViewEnumMyOrg',
  personality: 'ReportViewEnumPersonality',
}